import { render } from "./FormaRezerva.vue?vue&type=template&id=245b8fd4"
import script from "./FormaRezerva.vue?vue&type=script&lang=js"
export * from "./FormaRezerva.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__